import React from "react"
import { Dropdown, Menu } from "antd"
import ConfirmModal from "@/UI/Modals/ConfirmModal"
import { faTrashCan, faEllipsis, faPen } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { DropdownItemContainer } from "../../OrganizationSettings/components/OrgUsersActionsMenu"
import { useTranslation } from "react-i18next"
import { useTeams } from "@/hooks/useTeams"
import MenuItem from "antd/lib/menu/MenuItem"
import CreateTeamModal from "./CreateTeamModal"
import { EnrichedTeam } from "@/types/teams.types"
import { useRecoilValue } from "recoil"
import { isManagerSelector } from "@/atoms/userAtom"

interface TeamsTableActionsCellProps {
  team: EnrichedTeam
}

const TeamsTableActionsCell: React.FC<TeamsTableActionsCellProps> = ({ team }) => {
  const { t } = useTranslation()
  const { removeTeam, isLoading } = useTeams()
  const isManager = useRecoilValue(isManagerSelector)

  return (
    <div className="col-span-1 text-center cursor-pointer select-none">
      <Dropdown
        overlay={
          <Menu>
            <MenuItem className="first:flex first:w-full" key={0}>
              <CreateTeamModal
                team={team}
                button={
                  <div className="flex w-full">
                    <DropdownItemContainer text={t("common.edit")} icon={faPen} />
                  </div>
                }
              />
            </MenuItem>
            {!isManager && (
              <Menu.Item key={1}>
                <ConfirmModal
                  isLoading={isLoading}
                  button={
                    <div className="w-full">
                      <DropdownItemContainer text={t("common.remove")} icon={faTrashCan} />
                    </div>
                  }
                  content={{
                    type: "danger",
                    title: t("profile.TeamsSettings.removeTeam"),
                    description: t("profile.TeamsSettings.removeTeamConfirmation"),
                    cancelText: t("common.cancel"),
                    okText: t("common.yesDelete"),
                  }}
                  onConfirm={() => removeTeam(team.id)}
                />
              </Menu.Item>
            )}
          </Menu>
        }
        trigger={["click"]}
      >
        <div className={"flex justify-center"}>
          <FontAwesomeIcon
            className="flex-shrink-0 h-4 text-gray-500 text-base cursor-pointer"
            icon={faEllipsis}
          />
        </div>
      </Dropdown>
    </div>
  )
}

export default TeamsTableActionsCell
